import styled, { css, keyframes } from "styled-components";

/* ---------- styles ---------- */

const bp = { md: "768px" };

const c = {
  black: "#1e1e1e",
  gold: "#c9a227",
  pink: "#fc9ac4",
  pinkStrong: "#ff77b4",
  white: "#ffffff",
};

export const Wrap = styled.section`
  margin: 170px 0 18px;
  @media (max-width: ${bp.md}) {
    margin: 150px 0 18px;
  }
`;

export const Frame = styled.div`
  position: relative;
  border-radius: 18px;

  background: transparent; /* 🔥 fără alb */
  border: none; /* 🔥 fără contur */

  overflow: hidden;
`;

export const Track = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 100%;

  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;

  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Slide = styled.div`
  position: relative;
  scroll-snap-align: start;

  height: clamp(580px, 70vh, 860px);

  @media (max-width: ${bp.md}) {
    height: auto; /* 👈 nu mai forțăm 300px */
  }
`;
export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  /* 🔥 mutăm focus-ul mai sus */
  object-position: center 40%;

  display: block;

  /* 🔥 reducem ușor impresia de zoom */
  transform: scale(0.95);
`;

export const Overlay = styled.div`
  position: absolute;

  /* fără degradeuri agresive; doar umbre fine pe margini */
  box-shadow:
    inset 0 0 0 1px rgba(255, 255, 255, 0.26),
    inset 0 -40px 60px rgba(0, 0, 0, 0.08);
`;

export const NavBtnBase = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;

  width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(201, 162, 39, 0.35);
  background: rgba(30, 30, 30, 0.75);
  color: ${c.pink};

  font-size: 26px;
  font-weight: 900;
  cursor: pointer;

  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);

  &:active {
    transform: translateY(-50%) scale(0.98);
  }
`;

export const NavBtnLeft = styled(NavBtnBase)`
  left: 4px; /* mai aproape de margine */

  @media (max-width: 768px) {
    left: 8px;
  }
`;

export const NavBtnRight = styled(NavBtnBase)`
  right: 4px; /* mai aproape de margine */

  @media (max-width: 768px) {
    right: 8px;
  }
`;

export const Dots = styled.div`
  margin-top: 6px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background: transparent;
  box-shadow: none;
  padding: 0;
`;

export const Dot = styled.button`
  width: ${(p) => (p.$active ? "22px" : "10px")};
  height: 10px;
  border-radius: 999px;

  border: 1px solid
    ${(p) => (p.$active ? "rgba(255, 119, 180, 0.9)" : "rgba(0,0,0,0.28)")};

  background: ${(p) =>
    p.$active ? "rgba(255, 119, 180, 0.9)" : "transparent"};

  box-shadow: none; /* 🔥 scoatem umbra complet */
  cursor: pointer;
  transition: 0.18s ease;

  &:hover {
    border-color: rgba(0, 0, 0, 0.42);
  }
`;

export const Content = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 28px;
  z-index: 4;

  display: grid;
  justify-items: center;
  gap: 5px;

  text-align: center;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: clamp(18px, 2.3vw, 32px);
  font-weight: 700;
  letter-spacing: 0.5px;
  font-family: "Ephesis", cursive;
  color: #a48423;

  /* umbră fină, naturală */
  text-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
`;

export const SubTitle = styled.p`
  margin: 0;
  max-width: 520px;
  font-size: clamp(12px, 1.3vw, 15px);
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 10px 24px rgba(0, 0, 0, 0.45);
`;

export const CtaBtn = styled.button`
  padding: 10px 20px;

  background: rgba(0, 0, 0, 0.65);
  border: none;
  border-radius: 20px; /* 🔥 colțuri mici, elegante */
  font-family: "Cormorant Garamond", serif;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
  color: ${c.pink};
  font-weight: 600;
  letter-spacing: 0.4px;

  cursor: pointer;

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);

  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.98);
  }
`;
